export default {
  methods: {
    goToSurvey() {
      if (!this.$auth.loading && !this.$auth.isAuthenticated) {
        this.$auth.loginWithRedirect({
          appState: { targetUrl: '/callback/survey' },
        });
      } else if (!this.$auth.loading && this.$auth.isAuthenticated) {
        this.$router.push('survey');
      }
    },
  },
};
